import app from '../../scripts/app';
import template from './tarifScreen.jade';

const sendAnalitics = (action, offerId) => {
  window.ca('event', {
    name: 'oldevent',
    category: 'New_ad',
    action,
    label: offerId,
  })
};

const tarifsAnalitics = {
  fast: 'tariff_1',
  safe: 'tariff_2',
  fastSafe: 'tariff_3',
};

app.directive('tarifScreen', [() => {

  return {
    restrict: 'E',
    replace: true,
    template,
    scope: {
      onSkip: '&',
      onTarifClick: '&',
    },
    controller: ['$scope', '$rootScope', ($scope, $rootScope) => {

      const offerId = $rootScope.ad && $rootScope.ad.id;

      sendAnalitics('tariff_choose', offerId);

      $scope.onChoise = (tarif) => {

        sendAnalitics(tarifsAnalitics[tarif], offerId);

        $scope.onTarifClick({tarif});
      };

      $scope.onSkiped = () => {

        sendAnalitics('tariff_skip', offerId);

        $scope.onSkip();
      };
    }],
    controllerAs: 'tarifScreenCtrl',
  };
}]);
